<template>
  <div id="Main">
    <!-- QR 바코드북 + 히어로: 하나의 카드로 붙여서 노출 -->
    <div class="top-block">
      <!-- QR 바코드북: 헤더 바로 아래 맨 위 -->
      <div class="qr-main-wrapper">
        <img
          class="qr-main-image"
          src="@/assets/images/qr-main.png"
          alt="QR 이벤트"
          @click="goToQrEvent"
        />
      </div>

      <!-- 1. 히어로: 스토어의 핵심 메시지 + 두 개의 입구 + 입점 브랜드 -->
      <section class="hero">
        <div class="hero-inner">
          <div class="hero-text">
            <span class="hero-label">LAB MANAGER STORE</span>
            <h1>실험에 필요한<br />모든 것을<br /><mark>가장 저렴하게</mark></h1>
            <p class="hero-sub">연구실 구매, 이제 한 곳에서</p>
            <div class="hero-cta">
              <button class="btn-yellow" @click="goChemical()">
                화학물질 둘러보기 <span>→</span>
              </button>
              <button class="btn-outline" @click="goSupplies()">
                실험용품/기기 둘러보기 <span>→</span>
              </button>
            </div>
          </div>

          <div class="hero-brands" v-if="heroBrands.length > 0">
            <div class="hero-brands-title">입점 브랜드</div>
            <div class="logos">
              <button
                class="logo"
                v-for="brand in heroBrands"
                :key="brand.id"
                @click="goBrand(brand.id)"
              >
                <img :src="brand.image" alt="" />
              </button>
            </div>
            <button class="brands-more" @click="goBrandPage">
              전체 브랜드 보기 →
            </button>
          </div>
        </div>

        <!-- 4가지 강점 -->
        <ul class="hero-points">
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="6" width="18" height="13" rx="2" />
              <path d="M3 10h18M16 14.5h2" />
            </svg>
            <span>온라인 최저가로<br />가장 저렴하게</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7" />
              <circle cx="7" cy="17.5" r="1.8" />
              <circle cx="17" cy="17.5" r="1.8" />
            </svg>
            <span>제조사 직배송으로<br />안전하고 빠르게</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6" />
            </svg>
            <span>영수증 정리는<br />월 1회 간편하게</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 5h16v11H9l-5 4z" />
              <path d="M8.5 10.5h.01M12 10.5h.01M15.5 10.5h.01" />
            </svg>
            <span>재고 문의는<br />채팅으로 빠르게</span>
          </li>
        </ul>
      </section>
    </div>

    <!-- 이벤트 배너: 크기를 줄여(1080x230) 첫 화면에서 보이게 한다. 등록된 배너가 있을 때만 -->
    <div class="banner-wrapper" v-if="banners && banners.length > 0">
      <banners />
    </div>

    <div class="wrapper">
      <!-- 3. 랩매니저 스토어가 특별한 이유 -->
      <section class="reasons">
        <h2 class="section-title">랩매니저 스토어가 특별한 이유</h2>
        <ul>
          <li v-for="reason in reasons" :key="reason.no">
            <span class="no">{{ reason.no }}</span>
            <b class="title">{{ reason.title }}</b>
            <p class="desc">{{ reason.desc }}</p>
          </li>
        </ul>
      </section>

      <!-- 4. 무엇을 찾으세요? -->
      <section class="finder">
        <h2 class="section-title">무엇을 찾으세요?</h2>
        <div class="finder-grid">
          <div class="finder-card chemical">
            <div class="head">
              <b>화학물질</b>
              <span>시약 · 표준품 · 바이오</span>
            </div>
            <div class="chips">
              <button v-for="tag in chemicalTags" :key="tag" @click="goChemical(tag)">
                {{ tag }}
              </button>
            </div>
            <form class="quick-search" @submit.prevent="searchChemical">
              <input
                v-model.trim="chemicalKeyword"
                type="text"
                placeholder="CAS No, 시약명, 제품번호로 바로 검색"
              />
              <button type="submit">검색</button>
            </form>
            <button class="go" @click="goChemical()">화학물질 전체 보기 →</button>
          </div>

          <div class="finder-card supplies">
            <div class="head">
              <b>실험용품/기기</b>
              <span>
                소모품 · 안전용품 · 사무용품 · 장비
                <template v-if="suppliesTotal > 0">
                  · 총 {{ suppliesTotal.toLocaleString("ko-KR") }}개
                </template>
              </span>
            </div>
            <div class="chips">
              <button
                v-for="category in supplyCategories"
                :key="category.idx"
                @click="goSupplies(category.idx)"
              >
                {{ category.name }}
              </button>
            </div>
            <form class="quick-search" @submit.prevent="searchSupplies">
              <input
                v-model.trim="suppliesKeyword"
                type="text"
                placeholder="상품명, 브랜드로 바로 검색"
              />
              <button type="submit">검색</button>
            </form>
            <button class="go" @click="goSupplies()">실험용품/기기 전체 보기 →</button>
          </div>
        </div>
      </section>
    </div>

    <modal-popup :list="popupListFilter" />
    <modal-cancel
      title="주문이 필요한 상품 삭제"
      content="삭제된 상품은 다시 볼 수 없습니다.<br>주문이 필요한 상품을 삭제 하시겠습니까?"
      @ok="deleteRequiredProduct"
    />
  </div>
</template>

<script>
import Banners from "@/views/main/components/Banners.vue";
import ModalCancel from "@/components/modal/ModalCancel";
import ModalPopup from "@/views/main/modal/ModalPopup.vue";
import cookies from "vue-cookies";
import { mapActions, mapGetters, mapState } from "vuex";
import { ToastType } from "@/utils/define/ToastType";
import gaAPI from "@/utils/ga/api";
import suppliesAPI from "@/services/api/supplies";
import PageName from "@/utils/define/PageName";

export default {
  name: "Main",
  components: {
    Banners,
    ModalCancel,
    ModalPopup,
  },
  data() {
    return {
      deleteId: 0,
      chemicalTags: ["시약", "표준품", "바이오"],
      chemicalKeyword: "",
      suppliesKeyword: "",
      supplyCategories: [], // 실험용품/기기 대분류 [{ idx, name, count }]
      reasons: [
        {
          no: "01",
          title: "온라인 최저가로 연구비 부담 ↓",
          desc: "Merck 제품 10% 할인을 비롯해 국내 브랜드 제품 최대 25% 할인까지, 다양한 할인 혜택으로 연구에 필요한 비용을 절감할 수 있습니다.",
        },
        {
          no: "02",
          title: "제조사가 직접! 안전하고 빠른 배송",
          desc: "주문 확인부터 출고, 배송까지 제조사의 관리 아래 진행되어 유통 과정을 명확하게 확인할 수 있고, 더 빠르게 상품을 받아볼 수 있습니다.",
        },
        {
          no: "03",
          title: "실시간 견적 출력, 월 1회 통합 결제서류",
          desc: "번거로운 견적 문의 없이 스토어에서 견적서를 바로 출력하고, 월 1회 통합 결제서류로 편리하게 정산할 수 있습니다.",
        },
        {
          no: "04",
          title: "각종 문의사항은 채팅 상담으로 즉시 해결!",
          desc: "재고, 수량부터 배송 일정, 주문 관련 문의까지 모두 실시간 채팅 상담으로 확인할 수 있습니다.",
        },
      ],
    };
  },
  computed: {
    ...mapState("main", ["banners"]),
    ...mapState("brand", ["brandImageList"]),
    ...mapGetters("user", ["instituteId", "instituteName", "userInfo"]),
    ...mapState("popup", ["popupList"]),
    // 히어로 카드에 보여줄 입점 브랜드 로고 (API가 주요 브랜드를 앞에 내려준다)
    heroBrands() {
      return (this.brandImageList || []).slice(0, 12);
    },
    suppliesTotal() {
      return this.supplyCategories.reduce((sum, v) => sum + v.count, 0);
    },
    popupListFilter() {
      return this.popupList.filter(
        (popup) => !cookies.isKey(`popup_${popup.id}`)
      );
    },
    isEmptyPopupListFilter() {
      return this.$_.isEmpty(this.popupListFilter);
    },
  },
  watch: {
    instituteId: {
      async handler(newVal, oldVal) {
        if (!newVal) return;

        if (!oldVal) {
          gaAPI.gaEventLogin({
            institute_id: this.instituteId,
            institute_name: this.instituteName,
            lab_id: this.instituteId,
            lab_name: this.instituteName,
            user_id: this.userInfo?.id,
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchPopupList();
  },
  async mounted() {
    this.loadList();

    if (this.$route.params.isFromStart) await this.getInstitute();
  },
  methods: {
    ...mapActions("user", ["getInstitute"]),
    ...mapActions("main", ["lookupBanners"]),
    ...mapActions("brand", ["lookupBrandImageList"]),
    ...mapActions("popup", ["lookupPopupList"]),
    loadList() {
      this.lookupBanners();
      // 입점 브랜드 이미지 목록 조회
      this.lookupBrandImageList();
      this.loadSupplyCategories();
    },
    // 실험용품/기기 대분류 (개수가 있는 것만)
    async loadSupplyCategories() {
      try {
        const { data } = await suppliesAPI.lookupCategories();
        this.supplyCategories = data.filter((v) => v.count > 0);
      } catch (e) {
        this.supplyCategories = [];
      }
    },
    async fetchPopupList() {
      try {
        await this.lookupPopupList();
        if (!this.isEmptyPopupListFilter) this.$bvModal.show("ModalPopup");
      } catch (e) {
        this.$root.toast("에러", e.response.data.msg, ToastType.ERROR);
      }
    },
    // 화학물질 목록 (tag가 있으면 해당 태그를 선택한 상태로)
    goChemical(tag) {
      const query = tag ? { tags: tag } : { classification: "" };
      this.$router.push({ path: "/search", query }).catch(() => {});
    },
    // 실험용품/기기 (대분류 idx가 있으면 해당 카테고리로)
    goSupplies(parentIdx) {
      this.$router
        .push({
          name: PageName.Supplies,
          query: parentIdx ? { p: String(parentIdx) } : {},
        })
        .catch(() => {});
    },
    // 화학물질 바로 검색 (입력이 없으면 목록으로)
    searchChemical() {
      if (!this.chemicalKeyword) return this.goChemical();
      this.$router
        .push({ path: "/search", query: { keyword: this.chemicalKeyword, type: "ALL" } })
        .catch(() => {});
    },
    // 실험용품/기기 바로 검색 (입력이 없으면 목록으로)
    searchSupplies() {
      this.$router
        .push({
          name: PageName.Supplies,
          query: this.suppliesKeyword ? { q: this.suppliesKeyword } : {},
        })
        .catch(() => {});
    },
    goBrand(id) {
      this.$router.push({ path: "/search/brand", query: { id } }).catch(() => {});
    },
    goBrandPage() {
      this.$router
        .push({ name: PageName.List, params: { category: "brand" } })
        .catch(() => {});
    },
    goToQrEvent() {
      window.open("https://store.lab-manager.com/product/list/sale/1838668");
    },
    showModalDelete(product) {
      this.deleteId = product.id;
      this.$bvModal.show("ModalCancel");
    },
    deleteRequiredProduct() {
      console.log(this.deleteId);
    },
  },
};
</script>

<style lang="scss" scoped>
$YELLOW: #fabf14;
$INK: #161616;

#Main {
  .section-title {
    margin: 0 0 22px;
    font-size: 1.5rem;
    font-weight: 800;
    color: $INK;
  }

  /* QR 바코드북 + 히어로를 붙인 하나의 카드 */
  .top-block {
    width: 1080px;
    margin: 14px auto 0;
    border-radius: 18px;
    overflow: hidden;
    /* QR 이미지의 투명한 여백이 히어로와 같은 색으로 보이도록 */
    background: #fffbea;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1);
  }

  /* ---------- 1. 히어로: 연한 크림 배경 + 노랑은 포인트로만 ---------- */
  .hero {
    position: relative;
    overflow: hidden;
    background: #fffbea;
    padding: 30px 32px 28px;

    .hero-inner,
    .hero-points {
      position: relative;
      z-index: 1;
    }

    .hero-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 40px;
      width: 100%;
      margin: 0;

      /* 브랜드 카드 뒤에 겹쳐 깔리는 노란 원 (노랑은 포인트로만) */
      &:before {
        content: "";
        position: absolute;
        top: -80px;
        right: -110px;
        z-index: -1;
        width: 420px;
        height: 420px;
        border-radius: 50%;
        background: $YELLOW;
      }
    }

    .hero-text {
      flex: 1;
      .hero-label {
        display: inline-block;
        padding: 5px 12px;
        border-radius: 14px;
        background: $YELLOW;
        font-size: 0.75rem;
        font-weight: 800;
        letter-spacing: 0.14em;
        color: $INK;
      }
      h1 {
        margin: 18px 0 16px;
        font-size: 3.2rem;
        font-weight: 900;
        line-height: 1.22;
        letter-spacing: -0.02em;
        color: $INK;
        /* 마지막 줄에 노란 형광펜 */
        mark {
          padding: 0 4px;
          background: linear-gradient(transparent 62%, $YELLOW 62%);
          color: inherit;
        }
      }
      .hero-sub {
        margin: 0;
        font-size: 1.15rem;
        font-weight: 600;
        color: #444;
      }
      .hero-cta {
        /* 문구와 버튼 사이 26px */
        margin-top: 26px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        button {
          height: 52px;
          padding: 0 24px;
          border-radius: 26px;
          font-size: 1rem;
          font-weight: 800;
          cursor: pointer;
          transition: transform 0.15s, box-shadow 0.15s;
          span {
            margin-left: 4px;
          }
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
          }
        }
        .btn-yellow {
          background: $YELLOW;
          color: $INK;
        }
        .btn-outline {
          border: 2px solid $INK;
          background: #fff;
          color: $INK;
        }
      }
    }

    .hero-brands {
      flex: 0 0 470px;
      padding: 22px 22px 14px;
      border-radius: 18px;
      background: #fff;
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.16);

      .hero-brands-title {
        margin-bottom: 14px;
        font-size: 0.95rem;
        font-weight: 800;
        color: $INK;
      }
      .logos {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 58px;
          padding: 6px 10px;
          border: 1px solid #f0f0f0;
          border-radius: 10px;
          background: #fff;
          cursor: pointer;
          transition: border-color 0.15s, box-shadow 0.15s;
          &:hover {
            border-color: $YELLOW;
            box-shadow: 0 0 0 3px #fff4cf;
          }
          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }
      }
      .brands-more {
        display: block;
        margin: 12px 0 0 auto;
        padding: 6px 2px;
        font-size: 0.85rem;
        font-weight: 700;
        color: $INK;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .hero-points {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;
      width: 100%;
      margin: 26px 0 0;
      padding: 0;
      list-style: none;
      li {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 16px;
        border: 1px solid #eee;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
        svg {
          flex: 0 0 28px;
          width: 28px;
          height: 28px;
          fill: none;
          stroke: $INK;
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
        span {
          font-size: 0.85rem;
          font-weight: 700;
          line-height: 1.4;
          color: $INK;
        }
      }
    }
  }

  /* 이벤트 배너: 원본(3200x800)을 가로 1080에 맞추고 위아래를 살짝 잘라 높이 230으로 */
  .banner-wrapper {
    width: 1080px;
    margin: 20px auto 0;
    ::v-deep .banner-container {
      height: 230px;
      border-radius: 14px;
      overflow: hidden;
      .banner-image {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .prev,
      .next {
        width: 40px;
        height: 40px;
        img {
          display: block;
          width: 40px;
          height: 40px;
        }
      }
      .prev {
        left: 12px;
      }
      .next {
        right: 12px;
      }
    }
  }

  .wrapper {
    padding-bottom: 20px;
  }

  /* ---------- 3. 특별한 이유 ---------- */
  .reasons {
    margin-top: 64px;
    ul {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    li {
      padding: 24px 20px 22px;
      border: 1px solid #eee;
      border-radius: 16px;
      background: #fff;
      transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
      &:hover {
        border-color: $YELLOW;
        box-shadow: 0 8px 22px rgba(250, 191, 20, 0.18);
        transform: translateY(-2px);
      }
      .no {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 38px;
        height: 28px;
        padding: 0 10px;
        border-radius: 14px;
        background: $YELLOW;
        font-size: 0.85rem;
        font-weight: 900;
        color: $INK;
      }
      .title {
        display: block;
        margin: 14px 0 8px;
        font-size: 1.02rem;
        line-height: 1.4;
        color: $INK;
      }
      .desc {
        margin: 0;
        font-size: 0.85rem;
        line-height: 1.6;
        color: #666;
      }
    }
  }

  /* ---------- 4. 무엇을 찾으세요? ---------- */
  .finder {
    margin-top: 64px;
    .finder-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }
    .finder-card {
      display: flex;
      flex-direction: column;
      padding: 28px;
      border-radius: 18px;
      .head {
        b {
          display: block;
          font-size: 1.5rem;
          font-weight: 900;
          color: $INK;
        }
        span {
          display: block;
          margin-top: 6px;
          font-size: 0.9rem;
          color: #555;
        }
      }
      .chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin: 20px 0 22px;
        button {
          height: 36px;
          padding: 0 16px;
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-radius: 18px;
          background: #fff;
          font-size: 0.9rem;
          font-weight: 700;
          color: $INK;
          cursor: pointer;
          transition: background-color 0.15s, border-color 0.15s;
          &:hover {
            border-color: $INK;
            background: #fffbea;
          }
        }
      }
      .quick-search {
        display: flex;
        gap: 8px;
        margin-bottom: 22px;
        input {
          flex: 1;
          min-width: 0;
          height: 46px;
          padding: 0 18px;
          border: 1px solid rgba(0, 0, 0, 0.14);
          border-radius: 23px;
          background: #fff;
          font-size: 0.9rem;
          &:focus {
            outline: none;
            border-color: $INK;
          }
        }
        button {
          height: 46px;
          padding: 0 22px;
          border-radius: 23px;
          background: $INK;
          font-size: 0.9rem;
          font-weight: 800;
          color: #fff;
          cursor: pointer;
        }
      }
      .go {
        align-self: flex-start;
        margin-top: auto;
        padding: 0;
        font-size: 0.95rem;
        font-weight: 800;
        color: $INK;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      &.chemical {
        background: #fff4cf;
      }
      &.supplies {
        background: #f3f5f8;
      }
    }
  }

  /* ---------- 5. QR 바코드북 ---------- */
  .qr-main-wrapper {
    width: 100%;
    margin: 0;
    .qr-main-image {
      display: block;
      width: 100%;
      height: auto;
      cursor: pointer;
    }
  }
}
</style>
